/**
 * css module
 * @description 支持less. 约定以 .module.css / .module.less 的样式启动css module
 * @see cra v5 之后，支持tailwind.css，建议使用tailwind.css及jss方案，如emotion.
 * @see https://www.tailwindcss.cn/
 * @see https://emotion.sh/docs/introduction
 */

import Merge from "./merge";
import ZdHome from "@/routes/zd/home";
import Chat from "./chat";
import React, { useState, useEffect } from "react";

export default function Index() {
  const [] = useState("");
  useEffect(() => {
    const newhash = window.sessionStorage.getItem("hash");
    if (newhash) {
      if (window.location.href.includes("#/single")) {
        window.location.href = window.location.href;
        return;
      }
      if (window.location.href.includes("#/newChat")) {
        window.sessionStorage.removeItem("hash");
        window.location.href = window.location.href;
        return;
      }
      window.location.href = window.location.href + newhash;
      window.sessionStorage.removeItem("hash");
    }
  }, []);

  return window.zdvisitLink ? (
    window.location.href.includes("#/zdChat") ? (
      <Merge />
    ) : window.location.href.includes("#/single") ? (
      <>
        <Chat mode={"single"} />
      </>
    ) : (
      <>
        <ZdHome />
      </>
    )
  ) : (
    <Merge />
  );
}
